import React, { ReactNode } from 'react';
import { ChatInputProvider } from '@/providers/chat-input-provider';
import { OnboardingProgressProvider } from '@/providers/onboarding-progress-provider';
import { CleanupProgressProvider } from '@/providers/cleanup-progress-provider';
import { ProgressSidebar } from '@/components/onboarding-progress/progress-sidebar';
import { CleanupProgressSidebar } from '@/components/cleanup-progress/cleanup-progress-sidebar';
import { ResourcesSidebar } from '@/components/resources/resources-sidebar';
import { ControlPanelSidebar } from '@/components/control-panel/control-panel-sidebar';
import type { AgentLayoutId } from './agent-config';
import { paths } from '@/config/paths';

export interface NavItem {
  label: string;
  to: string;
}

export interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

export interface AgentLayout {
  navItems: NavItem[];
  LeftSidebar: React.ComponentType<SidebarProps> | null;
  RightSidebar: React.ComponentType<SidebarProps> | null;
  wrapWithProviders: (threadId: string | null, children: ReactNode) => ReactNode;
}

export const LAYOUT_REGISTRY: Record<AgentLayoutId, AgentLayout> = {
  onboarding: {
    navItems: [
      { label: 'Assistant', to: paths.Assistant },
      { label: 'Best Practices', to: paths.BestPractices },
    ],
    LeftSidebar: ProgressSidebar,
    RightSidebar: ResourcesSidebar,
    wrapWithProviders: (threadId, children) => (
      <OnboardingProgressProvider threadId={threadId}>
        <ChatInputProvider>{children}</ChatInputProvider>
      </OnboardingProgressProvider>
    ),
  },
  generic: {
    navItems: [
      { label: 'Assistant', to: paths.Assistant },
    ],
    LeftSidebar: null,
    RightSidebar: null,
    wrapWithProviders: (_threadId, children) => (
      <ChatInputProvider>{children}</ChatInputProvider>
    ),
  },
  cleanup: {
    navItems: [
      { label: 'Assistant', to: paths.Assistant },
    ],
    LeftSidebar: CleanupProgressSidebar,
    RightSidebar: ControlPanelSidebar,
    wrapWithProviders: (threadId, children) => (
      <CleanupProgressProvider threadId={threadId}>
        <ChatInputProvider>{children}</ChatInputProvider>
      </CleanupProgressProvider>
    ),
  },
};
